import { Button, Card, CardContent, Grid, InputBase } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import {
    addToLocalList,
    updateLocalListItem,
} from '../../store/slices/localSlice';

export default function NotepadAddScreen() {
    const { state } = useLocation();
    const { id, note, title } = state || {};

    const [titleS, setTitle] = useState(title || '');
    const [noteS, setNote] = useState(note || '');

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const submitNote = () => {
        if (titleS.length < 2) {
            enqueueSnackbar('Title is too short', { variant: 'error' });
            return;
        }
        if (noteS.length < 20) {
            enqueueSnackbar(`Note is too short (${noteS.length}/20)`, {
                variant: 'error',
            });
            return;
        }
        if (id) {
            dispatch(
                updateLocalListItem({
                    list: 'notes',
                    data: { id, title: titleS, note: noteS },
                })
            );
            navigate(-2);
        } else {
            dispatch(
                addToLocalList({
                    list: 'notes',
                    data: { title: titleS, note: noteS },
                })
            );
            navigate(-1);
        }
    };

    return (
        <Screen authPass title={'Add Note'}>
            <Grid item xs={12}>
                <Card variant="outlined">
                    <CardContent>
                        <InputBase
                            fullWidth
                            className="mb-3"
                            placeholder="Type your title"
                            onChange={(e) => setTitle(e.target.value)}
                            value={titleS}
                        />
                        <InputBase
                            multiline
                            rows={(window, innerHeight / 50)}
                            fullWidth
                            placeholder="Note here"
                            onChange={(e) => setNote(e.target.value)}
                            value={noteS}
                        />
                    </CardContent>
                </Card>
                <Button
                    variant="contained"
                    onClick={submitNote}
                    className="mt-3"
                >
                    {id ? 'Update Note' : 'Add Note'}
                </Button>
            </Grid>
        </Screen>
    );
}
